import { put, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
var packageJson = require('../../package.json');

function* configGet() {
  const {res} = yield call(function () {
    const params = new URLSearchParams();
    params.append('version', packageJson.version);
    return axios.post(config.apiUri + "configApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  });

  if (res) {
    if (res.data.bool && res.data.config) {
      yield put({
        type: "CONFIG_SET",
        payload: {
          config: res.data.config,
        }
      });
    }
  }

}


const saga = [
  takeLatest('CONFIG_GET', configGet),
];

export default saga;
